module.exports = __webpack_public_path__ + "img/phone-01.15cc6574.png";